import { BackendEndpoint } from "@store-platform/backend/common"
import {
  LauncherIconCustomLink,
  Link,
  Profile,
  ProfileSettings,
  ProfileUpdateLegacyRequest,
  ProfileUpdateRequest,
  Testimonial,
} from "@store-platform/types"

export const endpointGetUserProfile: BackendEndpoint<Profile> = (
  username: string,
) => {
  return {
    method: "get",
    path: `/profile/${username}`,
    options: {
      next: { tags: [`profile-${username}`] },
    },
  }
}

export const endpointGetProfileSettings: BackendEndpoint<
  ProfileSettings
> = () => {
  return {
    method: "get",
    path: `/profile/settings`,
  }
}

export const endpointUpdateUserProfile_Legacy: BackendEndpoint<Profile> = (
  data: ProfileUpdateLegacyRequest,
) => {
  return {
    method: "patch",
    path: "/profile/legacy",
    data,
    options: {
      form: true,
    },
  }
}

type listReviewsByAppsOwnerResponse = {
  data: Testimonial[]
  metadata: {
    appCount: number
    reviewCount: number
  }
}

type ListReviewsByAppsOwnerParams = {
  limit?: number
  offset?: number
  search?: string
}

export const endpointListReviewsByAppsOwner: BackendEndpoint<
  listReviewsByAppsOwnerResponse
> = (username: string, params: ListReviewsByAppsOwnerParams) => {
  return {
    method: "get",
    path: `/profile/${username}/reviews`,
    queryParams: params,
    options: { next: { tags: ["app-reviews"] } },
  }
}

export const endpointListTopReviews: BackendEndpoint<Testimonial[]> = (
  username: string,
) => {
  return {
    method: "get",
    path: `/profile/${username}/reviews/top`,
    options: {
      next: { tags: ["top-reviews"] },
    },
  }
}

export const endpointPinUserReview: BackendEndpoint<void> = (
  reviewId: number,
) => {
  return {
    method: "post",
    path: `/profile/pinned-reviews/${reviewId}`,
  }
}

export const endpointUnpinUserReview: BackendEndpoint<void> = (
  reviewId: number,
) => {
  return {
    method: "delete",
    path: `/profile/pinned-reviews/${reviewId}`,
  }
}

export const endpointUpdateUsername: BackendEndpoint<void> = (
  username: string,
) => {
  return {
    method: "post",
    path: `/profile/username/${username}`,
  }
}

export const endpointUpdateUserProfile: BackendEndpoint<void> = (
  data: ProfileUpdateRequest,
) => {
  return {
    method: "patch",
    path: `/profile`,
    data,
  }
}

export const endpointUpdateProfilePicture: BackendEndpoint<{
  src: string
}> = (data: { profilePicture?: File }) => {
  return {
    method: "post",
    path: `/profile/pfp`,
    data,
    options: {
      form: true,
    },
  }
}

export const endpointUpdateProfileLink: BackendEndpoint<void> = (
  link: Link,
) => {
  return {
    method: "patch",
    path: `/profile/links`,
    data: { link },
  }
}

export const endpointUpdateProfileCustomLinks: BackendEndpoint<void> = (data: {
  links: LauncherIconCustomLink[]
}) => {
  return {
    method: "put",
    path: `/profile/links/custom`,
    data,
  }
}
